import React, { useState } from 'react';
import { Panel } from 'primereact/panel';
import './FAQ.css';

export default function FAQSection() {
    const [activeIndex, setActiveIndex] = useState(null);

    const togglePanel = (index) => {
        setActiveIndex((prev) => (prev === index ? null : index));
    };

    const faqs = [
        {
            header: "What happens when my free trial ends?",
            content:
                "Your access to premium features will stop. You can upgrade to a paid plan anytime to continue using all features without interruption.",
        },
        {
            header: "Can I upgrade or downgrade my plan?",
            content:
                "Yes, you can easily switch plans from your account dashboard at any time.",
        },
        {
            header: "Do you require any long-term commitments?",
            content:
                "No, our subscriptions are flexible. You can cancel or change your plan whenever you want.",
        },
        {
            header: "Can I avail an annual subscription plan?",
            content:
                "Yes, we offer both monthly and annual billing options. Annual plans come with a discount.",
        },
        {
            header: "Is there any cancellation fee or a lock-in period?",
            content: "No cancellation fees and no lock-in period. You’re free to cancel anytime.",
        },
        {
            header: "What types of payment do you accept?",
            content: "We accept major credit/debit cards, UPI, and net banking.",
        },
        {
            header: "Who owns my data?",
            content:
                "You retain complete ownership of your data. We only store and process it as needed to deliver the service.",
        },
        {
            header: "How safe is my data?",
            content:
                "Your data is protected with industry-standard encryption, secure cloud storage, and regular backups to ensure safety and confidentiality.",
        },
    ];

    return (
        <>
        <div className="flex justify-content-center align-items-center p-3 faq-outer-container surface-ground">
            <div className="w-full sm:w-11 md:w-9 lg:w-6 ">
                <h2 className="font-semibold mb-4 text-center">Frequently Asked Questions</h2>
                <div className="card space-y-3">
                    {faqs.map((faq, index) => (
                        <Panel
                            key={index}
                            header={faq.header}
                            toggleable
                            collapsed={activeIndex !== index}
                            onToggle={() => togglePanel(index)}
                        >
                            {faq.content}
                        </Panel>
                    ))}
                </div>
            </div>
        </div>
        </>
    );
}
